export default {
    template: document.querySelector('[data-quiz-code-template]') ?
        document.querySelector('[data-quiz-code-template]').innerHTML:
        null,
    props: {
        code: {
            type: Array,
        }
    },
    data() {
        return {

        };
    },
    watch: {
        code: {
            handler() {
                this.checkIfCodeComplete();
            }, deep: true
        }
    },
    methods: {
        checkIfCodeComplete() {
            const unCompleteEntry = this.code.find(x => ! x.complete);
            if (! unCompleteEntry) {
                this.codeComplete();
            }
        },

        codeComplete() {
            console.log('Code completed, congratulations!');
            this.$emit('code-complete');
        }
    },
    mounted() {

    }
}